// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pdf-container[data-v-56b8e72e]{background-color:#fff;padding-top:50px;height:100vh;width:100vw;position:fixed;top:0;left:0;z-index:99999}", ""]);
// Exports
module.exports = exports;
